<template>
    <section>
        <div v-if="loader.body" class="loading">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
        </div>

        <div v-else>
            <ui-table
                v-if="models.length"
                :columns="columns"
                :data="models"
                :selectable="contractsFeaturesIsAllowed"
                :loading="false"
                :table-header-fixed="false"
                :is-fixed-list="true"
                :last-col-fixed="true"
                :select-column-menu="true"
                name="ModelsTable"
                check-padding-left="20px"
                max-height="493px"
                not-found-text="Não foi possível encontrar nenhum modelo."
                not-found-icon="fa fa-file-contract"
                tr-component="contracts/list-models/table-line"
                custom-load-area
                disable-ref
                @select-all="selectedAll"
                @selected="selectedHandler"
            />

            <div v-else class="loading">
                <small>
                    Nenhum modelo foi cadastrado. Utilize o
                    <a href="#" @click="openGenerator">Gerador de Documentos e Contratos</a>
                    para cadastrar um novo.
                </small>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiTable, uiLoadIndicator } from '@/components/ui'

	import { deal } from '@/services/axios'

	const defaultLoader = () => ({
		body: false,
	})

	export default {
		name: 'contracts-list-models',

		components: {
			uiTable,
			uiLoadIndicator,
		},

		props: {
			dealId: {
				type: Number,
				default: undefined,
			},
			/**
			 * Modelos de documentos e contratos selecionados
			 */
			selectedModels: {
				type: Array,
				default() {
					return []
				}
			},
		},

		data() {
			return {
				models: [],
				openContent: false,
				allChecked: false,

				columns: [
					{ title: 'Nome' },
					{ title: 'Tipo' },
					{ title: 'Última atualização' },
					{ title: '' },
				],

				loader: { ...defaultLoader() },
				contractsFeaturesIsAllowed: false,
			}
		},

		computed: {
			/**
			 * Computed property que controla a seleção de modelos de documentos e contratos
			 */
			selectedModelsComputed: {
				get() {
					return this.selectedModels
				},
				set(value) {
					this.$emit('update:selectedModels', value)
				}
			},
		},

		async mounted() {
			this.$root.$on('contracts-features-is-allowed', (bool) => {
				// Verify if user_group is allowed to use contracts features
				this.contractsFeaturesIsAllowed = bool
			})

			this.$root.$on('contract-preview-model', async (payload) => {
				if (!payload) {
					this.$toastr.e('O ID do modelo selecionado é inválido')
					return
				}

				// Show loading warning
				this.$root.$emit('contracts-loading-warning', true)

				await this.openPreview(payload)

				// Disable loading warning
				this.$root.$emit('contracts-loading-warning', false)

				// Activate actions again
				this.$root.$emit('model-set-actions-status', { model_id: payload, status: false })
			})

			this.$root.$on('download-model', async (payload) => {
				if (!payload) {
					this.$toastr.e('O ID do modelo selecionado é inválido')
					return
				}

				await this.downloadModel(payload)

				// Activate actions again
				this.$root.$emit('model-set-actions-status', { model_id: payload, status: false })
			})

			await this.initModelsList()
		},

		beforeDestroy() {
			this.$root.$off('contracts-features-is-allowed')
			this.$root.$off('contract-preview-model')
		},

		methods: {
			selectedAll(bool) {
				this.$root.$emit('contract-selected-models--all', bool)
			},

			async getModelsList() {
				this.loader.body = true

				try {
					const { data } = await deal.getModels(this.dealId)
					this.models = data.data
				} catch (err) {
					console.log(err)
					this.models = []
				}

				this.loader.body = false
			},

			async initModelsList() {
				setTimeout(async () => {
					await this.getModelsList()
				}, 500)
			},

			selectedHandler(event) {
				let models = [...this.selectedModelsComputed].filter((item) => item.id != event.id)

				// Add if selected
				if (event.checked) {
					models.push({ id: event.id, file_id: event.file_id })
				}

				this.selectedModelsComputed = models
			},
			/**
			 * Abre o Gerador de Documentos e Contratos em uma nova aba
			 */
			openGenerator() {
				let route = this.$router.resolve({ name: 'sales.integrations.contractGeneration' })
				window.open(route.href, '_blank')
			},
			/**
			 * Abre a pré-visualização de um modelo de acordo com o ID passado
			 *
			 * @param {String|Number} modelId Identificador do modelo a ser visualizado
			 */
			async openPreview(modelId) {
				try {
					const { data } = await deal.getContractFromModel(modelId, this.dealId)
					const docURL = data.render.url.replace(/\//g, '__bar')

					// Open preview document iframe
					this.$nextTick(() => {
						const event = new CustomEvent('iframe--contracts-previewdoc', {
							detail: docURL,
						})
						window.parent.document.dispatchEvent(event)
					})

				} catch (error) {
					console.log(error)
					this.$toastr.e('Falha ao renderizar o arquivo!')
				}
			},
			/**
			 * Trata o evento de quando o download de um modelo é solicitado
			 */
			downloadModel(modelId) {
				return deal.getContractFromModel(modelId, this.dealId)
					.then(response => {
						window.open(response.data.render.url, "_blank")
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
